import { Box, styled } from '@mui/material';

export const StepsWrapper = styled(Box)(() => ({
	display: 'grid',
	flexDirection: 'column',
	gap: '16px',
}));
